<template>
  <div>
    <Row v-if="show_top" align="top">
      <Col :offset="0" :span="10">
        <Collapse simple>
          <Panel hide-arrow>
            <h3
              style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
            >{{ title }}</h3>
            <!-- :v-if="title_info.length() != 0" -->
            <div
              v-for="(item, index) of title_info"
              :key="index"
              slot="content"
              class="panel-content"
            >
              <p>
                <b>{{ item.name }}:</b>
                {{ item.value }}
              </p>
            </div>
          </Panel>
        </Collapse>
      </Col>
      <Col :offset="13" :span="1">
        <Button shape="circle" icon="md-download" @click="export_table_data"></Button>
      </Col>
    </Row>
    <Row v-if="show_top" style="height:15px;"></Row>
    <Row>
      <Table
        size="small"
        :stripe="true"
        :border="true"
        :columns="table_columns"
        :data="table_data_final"
        @on-sort-change="on_sort_change"
        
        :max-height="max_height"
        :height="height"
        @on-selection-change="this.selection_change"
      ></Table>
      <div style="margin: 10px;overflow: hidden" v-if="show_page">
        <div style="float: right;">
          <Page
            :total="table_total_num"
            :page-size="table_page_size"
            :page-size-opts="[10, 20, 50]"
            :show-sizer="true"
            :show-total="true"
            @on-change="on_table_page_change"
            @on-page-size-change="on_page_size_change"
          />
        </div>
      </div>
    </Row>
  </div>
</template>

<script>
import { array_to_object } from "../utils";
export default {
  name: "table_view",
  props: {
    title: {
      type: String,
      default: ""
    },
    show_page: {
      type: Boolean,
      default: true
    },
    title_info: {
      type: Array,
      default: []
    },
    table_data: {
      type: Array,
      default: []
    },
    table_columns: {
      type: Array,
      default: []
    },
    table_ref: {
      type: String,
      default: "table_ref"
    },
    table_page_size: {
      type: Number,
      default: 10
    },
    max_height: {
      type: Number,
      default: 600
    },
    height: {
      type: Number,
      default: null
    },
    // 对表格初始化，设置宽度、颜色、样式等内容
    init_table: {
      type: Function
    },
    // 列表表头名
    table_name_array: {
      type: Array
    },
    show_top: {
      type: Boolean,
      default: true
    },
    selection_change:{
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      table_page_number: 1,
      table_total_num:0,
      table_data_final:[],
    };
  },
  mounted() {
    this.init_table();
    this.draw_table();
  },
  watch: {
    table_data(old_value) {
      this.draw_table()
    }
  },
  methods: {
    // 根据当前页码，重新展示一遍数据
    draw_table: function() {
      const name_array = this.table_name_array;
      this.table_total_num = this.table_data.length;
      // 根据当前页码和每页可显示总数，重新渲染
      let start = (this.table_page_number - 1) * this.table_page_size;
      let end = start + this.table_page_size;
      var object = array_to_object(
        name_array,
        this.table_data.slice(start, end)
      );
      this.table_data_final = object;
    },
    on_sort_change: function(data) {
      function sortable(a, b) {
        if (order == "desc") {
          return b[index] > a[index] ? 1 : -1;
        } else {
          //asc
          return b[index] > a[index] ? -1 : 1;
        }
      }
      var key_index = {};
      for (var i = 0; i < this.table_name_array.length; i++) {
        key_index[this.table_name_array[i]] = i;
      }
      var index = key_index[data["key"]];
      var order = data["order"];
      this.table_data.sort(sortable);
      this.draw_table();
    },
    on_page_size_change: function(page_size) {
      this.table_page_size = page_size;
      this.draw_table();
    },
    on_table_page_change: function(page_number) {
      this.table_page_number = page_number;
      this.draw_table();
    },
    export_table_data: function() {
      console.log("test")
      console.log(this.table_ref)
      console.log(this.$refs)
      console.log(this.$refs.this.table_ref)
      console.log(this.table_columns)
      this.$refs[this.table_ref].exportCsv({
        filename: "record_data", //导出Excel的文件名
        data: array_to_object(this.table_name_array, this.table_data),
        columns: this.table_columns
      });
    }
  }
};
</script>
    
<style scoped>
</style>